import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/** Previzualizarea alocării unui profil de acces: câte structuri și rapoarte de muncă active acoperă, înainte de salvare. */
export default function CoverageHint({ scopeIds, categories }) {
  const [d, setD] = useState(null);
  const key = JSON.stringify([scopeIds, categories]);
  useEffect(() => {
    let live = true;
    const t = setTimeout(() => {
      api.post("/access/coverage", { scope_org_unit_ids: scopeIds, personnel_categories: categories })
        .then(r => { if (live) setD(r.data); }).catch(() => { if (live) setD(null); });
    }, 300);
    return () => { live = false; clearTimeout(t); };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const blocked = d.structures_blocked || [];
  return (
    <div data-testid="coverage-hint" style={{ marginTop: 8, fontSize: 12, padding: "6px 10px", borderRadius: 6,
      background: d.employments ? "#F0FDF4" : "#FEF2F2", color: d.employments ? "#166534" : "#991B1B",
      border: `1px solid ${d.employments ? "#BBF7D0" : "#FECACA"}` }}>
      Acoperă <b>{d.structures_reachable}</b> structuri și <b>{d.employments}</b> rapoarte de muncă active
      {Object.keys(d.by_category || {}).length > 1 && <> ({Object.entries(d.by_category).map(([k, v]) => `${k}: ${v}`).join(", ")})</>}.
      {d.employments === 0 && <> Nu există rapoarte active care să se potrivească — alege structura-părinte sau verifică categoria.</>}
      {blocked.length > 0 && <div>Blocate de o structură dezactivată: {blocked.join(", ")}.</div>}
    </div>
  );
}
